import React from 'react';

function TableContent({ headers, vehicleTrackingList, formData, setFormData }) {
  const handleCheckboxChange = (rowId, checked) => {
    if (checked) {
      setFormData((prev) => ({
        ...prev,
        vehicle_tracking_line_items: [
          ...prev.vehicle_tracking_line_items,
          { id: rowId, quantity: 0 }, // default quantity 0
        ],
      }));
    } else {
      // remove row from vehicle_tracking_line_items
      setFormData((prev) => ({
        ...prev,
        vehicle_tracking_line_items: prev.vehicle_tracking_line_items.filter(
          (item) => item.id !== rowId,
        ),
      }));
    }
  };

  const handleQuantityChange = (rowId, value) => {
    setFormData((prev) => ({
      ...prev,
      vehicle_tracking_line_items: prev.vehicle_tracking_line_items.map((i) =>
        i.id === rowId ? { ...i, quantity: Number(value) } : i,
      ),
    }));
  };

  const isChecked = (rowId) =>
    formData.vehicle_tracking_line_items?.some((item) => item.id === rowId);

  const getQuantity = (rowId) => {
    const foundItem = formData.vehicle_tracking_line_items?.find(
      (i) => i.id === rowId,
    );
    return foundItem?.quantity || '';
  };

  return (
    <tbody>
      {vehicleTrackingList && vehicleTrackingList.length > 0 ? (
        vehicleTrackingList.map((row) => (
          <tr key={row.id}>
            {headers.map((header) => (
              <td className="table-data div-align-center" key={header.value}>
                {header.value === 'po_number' ? (
                  <div className="div-flex-row">
                    <input
                      type="checkbox"
                      className="checkbox-grey"
                      checked={isChecked(row.id)}
                      onChange={(e) =>
                        handleCheckboxChange(row.id, e.target.checked)
                      }
                    />
                    <span className="left-padding">{row[header.value]}</span>
                  </div>
                ) : header.value === 'quantity' ? (
                  <input
                    type="number"
                    name="pickingQuantity"
                    value={getQuantity(row.id)}
                    onWheel={(e) => e.target.blur()}
                    min={0}
                    onChange={(e) => {
                      let value = Number(e.target.value);
                      const maxQty = Number(row.receiving_quantity);
                      if (value > maxQty) {
                        value = maxQty;
                      }
                      if (value < 0) {
                        value = 0;
                      }
                      handleQuantityChange(row.id, value);
                    }}
                    className="input-field-none-40 text-sm text-semi-bold"
                    disabled={!isChecked(row.id)}
                  />
                ) : (
                  <span>{row[header.value] ?? '-'}</span>
                )}
              </td>
            ))}
          </tr>
        ))
      ) : (
        <tr>
          <td colSpan={headers?.length} className="no-data-found border-bottom">
            <span className="text-sm">No Data Found</span>
          </td>
        </tr>
      )}
    </tbody>
  );
}

export default TableContent;
